export default "__VITE_ASSET__Dux$N0zR__"